﻿﻿export interface ILkdpiResults {
    gfr: number;
    index: number;
}
